module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-41-d6d588bdc2f00dbf6e82f0bd0d63523d.jpg";